import PurchaseOrderAset from './PurchaseOrderAset';

export default PurchaseOrderAset;
